import React from "react";
import "./CustomerList.scss";

interface IListItem {
  name: string;
  link?: string;
}

interface ICustomerListProps {
  listHeader: string;
  listItems: IListItem[];
}

export const CustomerList: React.FC<ICustomerListProps> = ({
  listHeader,
  listItems,
}) => {
  return (
    <div
      key={`CustomerList-${listHeader}`}
      className={`CustomerList CustomerList-${listHeader.replace(/\s/g, "-")}`}
    >
      <h3 className="CustomerList__list-header left-green-border">
        {listHeader}
      </h3>
      <div className="CustomerList__list-items">
        {listItems.map((item, index) => {
          return (
            <div
              key={`customer-list-item-${index}`}
              className={`CustomerList__list-item ${
                item.link ? "list-item-link-box" : ""
              }`}
            >
              {/*
              {item.link ? (
                <div className="CustomerList__list-item__link">
                  <a href={item.link}>{item.name}</a>
                  {/* <span>
                    <i className="fas fa-arrow-right"></i>
                  </span>}
                </div>
              ) : (
                <p>{item.name}</p>
              )}*/}
              <p>{item.name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};
